exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "[data-v-7f1d655e]{margin:0;padding:0;box-sizing:border-box}body[data-v-7f1d655e],html[data-v-7f1d655e]{width:100%;height:100vh;overflow-x:hidden}.bg[data-v-7f1d655e],.home-wrapper[data-v-7f1d655e]{width:100%;height:100vh}.top[data-v-7f1d655e]{width:100vw}.box[data-v-7f1d655e]{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center}.h5box[data-v-7f1d655e]{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;align-items:center}.pcTit[data-v-7f1d655e]{width:643px;height:400px;margin-right:41px;margin-top:-19px}.h5Tit[data-v-7f1d655e]{width:261px;height:162px;margin-top:-18px}.pcbtnbox[data-v-7f1d655e]{margin-top:40px}.h5btnbox[data-v-7f1d655e]{margin-top:-21px}.pcbtn[data-v-7f1d655e]{width:228px;height:228px}.h5btn[data-v-7f1d655e]{width:135px;height:135px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7f1d655e","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/home/index.vue
// module id = 183
// module chunks = 1